import * as React from 'react';
import propz from 'propz';
import { AppUser } from 'Src/views/App/App';
import { ROLE_SERVER_TO_CLIENT_MAPPING } from '../../../../consts/user';
import './UserName.scss';

interface Props {
  user: AppUser;
}

export function UserName(props: Props) {
  const { user } = props;
  const firstName = propz.get(user, ['profile', 'firstName'], '');
  const lastName = propz.get(user, ['profile', 'lastName'], '');
  const email = propz.get(user, ['profile', 'email'], '');
  const avatar = propz.get(user, ['profile', 'avatar'], '');
  const phone = propz.get(user, ['profile', 'phone'], '');
  const activeRole = propz.get(user, ['activeRole'], '');
  const activeSchoolName = propz.get(user, ['activeSchoolName'], '');
  const isEmailVerified = !!propz.get(user, ['profile', 'verification', 'status', 'email']);
  const isPhoneVerified = !!propz.get(user, ['profile', 'verification', 'status', 'sms']);
  const fullName = `${firstName} ${lastName}`.trim() || 'Your profile';
  const initials = `${firstName ? firstName.charAt(0) : ''}${lastName ? lastName.charAt(0) : ''}`.toUpperCase() || 'U';
  const roleName = ROLE_SERVER_TO_CLIENT_MAPPING[activeRole] || activeRole;

  return (
    <section className="upProfileHeader">
      <div className="upProfileAvatar" aria-hidden="true">
        {avatar ? <img src={avatar} alt="" /> : <span>{initials}</span>}
      </div>
      <div className="upProfileHeaderText">
        <div className="upProfileKicker">Profile</div>
        <h1>{fullName}</h1>
        {email && <p>{email}</p>}
        <div className="upProfileHeaderChips" aria-label="Account status">
          {roleName && <span className="upProfileHeaderChip upProfileHeaderChipRole">{roleName}</span>}
          {activeSchoolName && <span className="upProfileHeaderChip">{activeSchoolName}</span>}
          {email && (
            <span
              className={`upProfileHeaderChip ${
                isEmailVerified ? 'upProfileHeaderChipSuccess' : 'upProfileHeaderChipWarning'
              }`}
            >
              <span className="upProfileHeaderChipDot" aria-hidden="true" />
              {isEmailVerified ? 'Email verified' : 'Email not verified'}
            </span>
          )}
          {phone && (
            <span
              className={`upProfileHeaderChip ${
                isPhoneVerified ? 'upProfileHeaderChipSuccess' : 'upProfileHeaderChipWarning'
              }`}
            >
              <span className="upProfileHeaderChipDot" aria-hidden="true" />
              {isPhoneVerified ? 'Mobile verified' : 'Mobile not verified'}
            </span>
          )}
        </div>
      </div>
    </section>
  );
}
